import React, { useState, useEffect } from 'react';
import useApiControl from '../../../common/useApiControl';
import BaseForm from '../BaseForm';
import TextField from '@mui/material/TextField';

const LoginForm = ({ afterLogin, room_id } = {}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { data, error, loading, executeRequest } = useApiControl({
    action: '/login',
    params: { name:username, password:password },
    method: 'POST',
  });

  // イランかも
  // useEffect(() => {
  //   // ストレージにログイン情報があったら前もって削除
  //   if(localStorage.getItem('authToken') !== '' || localStorage.getItem('user') !== '') {
  //     localStorage.removeItem('authToken');
  //     localStorage.removeItem('user');
  //   }
  // }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    executeRequest();
  };

  // Responseを監視し、トークンとユーザー情報をlocalStorageに保存する
  useEffect(() => {
    if (data) {
      const { user, token} = data;
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify(user));
      if (afterLogin === 'room' && room_id) {
        // Room側のオーナー判定を通すため、ログイン後はいったん通常ルームURLへ戻す
        window.location.href = `/room?id=${room_id}`;
      } else if (afterLogin === 'owner' && room_id) {
        window.location.href = `/owner?id=${room_id}`;
      } else if(afterLogin === 'mypage'){


      } else {
        //戻り先設定してない場合
        window.location.reload();
      }
    }
  }, [data]);

  // Errorを監視し、401エラーをキャッチする
  useEffect(() => {
    if (error && error.response && error.response.status === 401) {
      setPassword('');
    }
  }, [error]);

  return (
    <BaseForm onSubmit={handleSubmit} submitLabel="ログイン" logMessage="Login Api start" apiError={error}>
      <h3>ログイン</h3>
      <TextField
        label="名前"
        variant="outlined"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <TextField
        label="パスワード"
        variant="outlined"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
    </BaseForm>
  );
};

export default LoginForm;
